export class SearchLogsHistogramInput {
    'resourceIds';
    'query';
    'startDate';
    'endDate';
    'restoreAccountId';
    'restoreBucket';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "startDate",
            "baseName": "startDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endDate",
            "baseName": "endDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "restoreBucket",
            "baseName": "restoreBucket",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchLogsHistogramInput.attributeTypeMap;
    }
    constructor() {
    }
}
